// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1cKgx","buttons":"Footer_buttons__3FaE0"};